import type { ReactNode } from 'react';

/**
 * loading / empty / error 3상태 공통 컴포넌트.
 * 기획서 Phase 1 요구사항: "loading/empty/error 상태를 반드시 구현한다".
 *
 * 접근성: 색상만으로 상태를 구분하지 않도록 아이콘 + 텍스트를 함께 제공한다.
 */

export function LoadingState({ label = '불러오는 중…' }: { label?: string }) {
  return (
    <div className="state" role="status" aria-live="polite">
      <div className="spinner" aria-hidden="true" />
      <div>{label}</div>
    </div>
  );
}

export function EmptyState({
  icon = '⬚',
  title,
  desc,
  action,
}: {
  icon?: string;
  title: string;
  desc?: string;
  action?: ReactNode;
}) {
  return (
    <div className="state">
      <div className="state__icon" aria-hidden="true">
        {icon}
      </div>
      <div className="state__title">{title}</div>
      {desc && <div>{desc}</div>}
      {action}
    </div>
  );
}

export function ErrorState({
  title = '문제가 발생했습니다',
  message,
  onRetry,
}: {
  title?: string;
  message: string;
  onRetry?: () => void;
}) {
  return (
    <div className="state state--error" role="alert">
      <div className="state__icon" aria-hidden="true">
        ⚠
      </div>
      <div className="state__title">{title}</div>
      <div>{message}</div>
      {onRetry && (
        <button type="button" className="btn" onClick={onRetry} style={{ marginTop: 8 }}>
          다시 시도
        </button>
      )}
    </div>
  );
}
